"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBankingData = addBankingData;
exports.default = void 0;
exports.getBankDetails = getBankDetails;
exports.getBusinessPartner = getBusinessPartner;
exports.getMyData = getMyData;
exports.getPersonalData = getPersonalData;
exports.getPhonenIdFromPhoneObject = getPhonenIdFromPhoneObject;
exports.getTaxVatNumbers = void 0;
exports.saveMyData = saveMyData;
exports.saveTaxVatNumber = void 0;
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _config = _interopRequireDefault(require("../config/config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function getMyData(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/mydata/").concat(contractId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getPersonalData(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/mydata/").concat(contractId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getBankDetails(iban) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/util/iban"), iban, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function addBankingData(bankDetailsObj, contractId) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/mydata/").concat(contractId, "/bankaccounts"), bankDetailsObj, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function saveMyData(contractId, emailData) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/mydata/").concat(contractId), emailData, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getBusinessPartner() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/businesspartners"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
var getTaxVatNumbers = exports.getTaxVatNumbers = function getTaxVatNumbers(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/mydata/").concat(contractAccountId, "/taxnumbers"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal)).then(function (response) {
    return {
      data: {
        taxin: response.data.taxin ? response.data.taxin : '',
        vatin: response.data.vatin ? response.data.vatin : 'DE'
      }
    };
  }).catch(function (error) {
    throw error;
  });
};
var saveTaxVatNumber = exports.saveTaxVatNumber = function saveTaxVatNumber(contractAccountId, data) {
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/mydata/").concat(contractAccountId, "/taxnumbers"), data, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
};

// @TODO find out if it exists
var refreshToken = function refreshToken() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/token"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
};
function getPhonenIdFromPhoneObject(phoneNumberObj) {
  return phoneNumberObj === null || phoneNumberObj === void 0 ? void 0 : phoneNumberObj.order;
}
var _default = exports.default = {
  saveMyData: saveMyData,
  getTaxVatNumbers: getTaxVatNumbers,
  saveTaxVatNumber: saveTaxVatNumber,
  getBusinessPartner: getBusinessPartner,
  getMyData: getMyData,
  getPersonalData: getPersonalData,
  refreshToken: refreshToken,
  getPhonenIdFromPhoneObject: getPhonenIdFromPhoneObject,
  getBankDetails: getBankDetails,
  addBankingData: addBankingData
};